/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import ReactModal from "react-modal";
import styles from "./styles.module.scss";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { BrComerceApiService } from "../../../../../../../services/BrComerceApiService";
import Swal from "sweetalert2";
import { Loading } from "../../../../../../../components/Loading";
import { StyledTooltip } from "../../../../../components/Tooltip";
import { Close } from "@material-ui/icons";

const stylesModal22 = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(51, 51, 51, 0.75)",
    zIndex: 999
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    zIndex: 999,
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    height: "90%",
    maxWidth: "1200px",
    maxHeight: "800px"
  }
};


export const EditPackageImageModal = ({
  isOpen,
  handleCloseButton,
  shipping,
  imageIndex,
  refetch
}) => {
  const [imgPreview, setImgPreview] = useState()
  const [selectedImage, setSelectedImage] = useState(null)
  const [loading, setLoading] = useState(false);
  const api = new BrComerceApiService()

  const fileInputRef = useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveImage = () => {
    setImgPreview()
    setSelectedImage("DELETE")
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
    }
  };

  useEffect(() => {
    if (shipping) {
      const { deliveriesData } = shipping
      if (!selectedImage && deliveriesData && deliveriesData[imageIndex]) {
        setImgPreview(deliveriesData[imageIndex]?.urlImage)
      } else if (selectedImage && typeof selectedImage !== "string") {
        setImgPreview(URL.createObjectURL(selectedImage))
      }
    }
  }, [shipping, imageIndex, selectedImage])

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { deliveriesData } = shipping;
    const delivery = deliveriesData[imageIndex];

    try {
      if (typeof selectedImage === "string") {
        Swal.fire({
          title: "Deseja apagar a imagem?",
          html:
            "Esta ação não poderá ser revertida.",
          icon: "warning",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          confirmButtonText: "Sim, fazer a deleção!"
        }).then(async response => {
          if (response?.value) {
            setLoading(true);
            await api.makeHttpRequest({
              method: "DELETE",
              url: `delivery-admin/${delivery?.id ?? ""}`,
            });

            refetch()
            Swal.fire({
              title: 'Sucesso!',
              text: 'Imagem apagada com sucesso.',
              icon: 'success'
            });
            handleCloseButton()
          }
        });
      } else {
        setLoading(true);

        const base64Image = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(selectedImage);
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = error => reject(error);
        });

        const data = {
          image_base64: base64Image,
          path: delivery?.s3_signature_path,
        }

        await api.makeHttpRequest({
          method: "PUT",
          url: `delivery-admin/signature/${delivery?.id ?? ""}`,
          data,
        });

        refetch()
        Swal.fire({
          title: 'Sucesso!',
          text: 'Imagem atualizada com sucesso.',
          icon: 'success'
        });
        handleCloseButton()
      }
    } catch (error) {
      return Swal.fire({
        title: 'Ops!',
        text: 'Erro ao atualizar imagem, tente novamente mais tarde',
        icon: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Loading loading={loading} />
      <ReactModal
        isOpen={isOpen}
        shouldCloseOnOverlayClick
        onRequestClose={() => handleCloseButton()}
        style={stylesModal22}
      >
        <div className={styles.contentBody}>
          <div className={styles.container}>
            {(shipping && imgPreview) ?
              (<div className={styles.imageContainer}>
                <StyledTooltip text={"Remover imagem"}
                >
                  <Close
                    style={{
                      width: 18,
                      height: 18,
                      cursor: "pointer",
                      color: "#FFF"
                    }}
                    onClick={handleRemoveImage}
                  />
                </StyledTooltip>
                <div className={styles.image}>
                  <TransformWrapper>
                    <TransformComponent>
                      <img
                        src={imgPreview}
                        alt="Imagem do objeto entregue"
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </div>
              </div>) : (
                <div className={styles.emptyImage}>
                  <p>Nenhuma imagem carregada</p>
                </div>
              )}

            <div className={styles.imageForm}>
              <div className={styles.inputFileContainer}>
                <div
                  className={`${styles.inputFile}`}
                  onClick={handleButtonClick}
                >
                  <span>
                    Inserir nova imagem
                  </span>
                </div>
              </div>
              <input type="file" accept="image/*" ref={fileInputRef} style={{ display: "none" }} onChange={handleImageChange} />
            </div>

            <div className={styles.buttonContainer}>
              <button
                type="button"
                onClick={() => handleCloseButton()}
                className={styles.buttonBack}
              >
                Cancelar
              </button>

              <button onClick={handleSubmit} disabled={!selectedImage || loading}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};
